<template lang="pug">
    .page
        transition(name="fade")
            .content(v-show="show")
                img.bg(src="@/assets/img/home_banner_1.png")
                .text-container
                    img.logo(src="@/assets/img/banner_logo.png")
                    .desc
                        p 专业风险投资机构
                        p 优质创业项目
                        p 与创业者携手「共创未来」
                    .tip
                        p 如欲了解部分被投企业，请点击图片查询
                        img.btn(src="@/assets/img/start.png", @click="show = false")
        Swiper.left(ref="swiperone", :options="optionsone", @slideChangeTransitionStart="slideChangeTransitionStart")
            SwiperSlide.item(style="background: #bf0000;")
                .crirle
                    .num 01
                    .line
                    .num 02
                .title 公司简介
                .desc 
                    p 龙腾资本是一家香港注册
                    p 的投资和资产管理公司
                .more 了解更多
            SwiperSlide.item(style="background: #3bb8aa;")
                .crirle
                    .num 02
                    .line
                    .num 02
                .title 初始合伙人
                .desc 
                    p 杨小雯女士Shirley Yeung
                    p 是龙腾资本的创始人
                    p 及管理合伙人
                .more 了解更多
        Swiper.right(ref="swiper", :options="options")
            SwiperSlide.item
                img.bg(src="@/assets/img/home_banner_3.png")
            SwiperSlide.item
                img.bg(src="@/assets/img/home_banner_2.png")
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
    name: 'Home',
    components: {
        Swiper,
        SwiperSlide
    },
    computed: {
        swiper() {
            return this.$refs.swiper.$swiper
        },
        swiperone() {
            return this.$refs.swiperone.$swiper
        },
    },
    data() {
        const that = this
        return {
            show: true,
            options: {
                autoplay: false,
                direction: 'vertical',
                delay: 5000,
                speed: 2000,
                loop: true,
                initialSlide: 1
            },
            optionsone: {
                autoplay: true,
                direction: 'vertical',
                delay: 5000,
                speed: 2000,
                loop: true,
                mousewheel: true,
                on: {
                    click: function(){
                       if (that.current) {
                           that.handleGoTeam()
                       } else {
                           that.handleGoCp()
                       }
                    }
                }
            },
            current: 0
        }
    },
    methods: {
        handleGoCp() {
            this.$router.push({ path: "/company"})
        },
        handleGoTeam() {
            this.$router.push({ path: "/team"})
        },
        handleStop() {
            if (this.swiperone.autoplay) this.swiperone.autoplay.stop()
        },
        slideChangeTransitionStart() {
            // console.log(this.swiperone.realIndex > this.current);
            
            if (this.swiperone.realIndex > this.current) {
                this.swiper.slidePrev()
                
            } else {
                this.swiper.slideNext()
            }
            this.current = this.swiperone.realIndex
        }
    },
    mounted() {
        const that = this
        document.addEventListener('scroll', () => {
            if (!that.show) {
                that.handleStop()
            }
        })
    }
}
</script>

<style lang="sass" scoped>
.page
    width: 100%
    height: 100vh
    .content
        height: 100vh
        width: 100%
        position: fixed
        z-index: 3
        .bg
            height: 100%
            width: 100%
            display: block
        .text-container
            height: 100%
            width: 100%
            display: flex
            justify-content: center
            align-items: center
            flex-direction: column
            position: absolute
            z-index: 1
            top: 0
            left: 0
            .logo
                width: 220px
                display: block
            .desc
                margin: 0.8em
                font-weight: bold
                text-align: center
                font-size: 2em
                color: #fff
                flex: 1
                display: flex
                flex-direction: column
                align-items: center
                justify-content: center
            .tip
                color: #999
                font-size: 12px
                text-align: center
                display: flex
                flex-direction: column
                justify-content: center
                align-items: center
                padding-bottom: 5%
            .btn
                cursor: pointer
                display: block
                margin-top: 1em
                height: 33px
                width: 33px
    .right
        height: 100vh
        width: 100%
        position: fixed
        box-sizing: border-box
        z-index: 1
        .item
            width: 100%
            height: 100%
            .bg
                width: 100%
                height: 100%
                display: block
                object-fit: cover
    .left
        height: 100vh
        width: 100%
        position: fixed
        box-sizing: border-box
        z-index: 2
        opacity: 0.9
        .item
            width: 100%
            height: 100vh
            display: flex
            justify-content: center
            align-items: center
            flex-direction: column
            .crirle
                height: 66px
                width: 66px
                border: 4px solid #333
                border-radius: 50%
                box-sizing: border-box
                display: flex
                justify-content: center
                align-items: center
                flex-direction: column
                font-size: 12px
                font-weight: bold
                .line
                    height: 2px
                    width: 2em
                    background: rgba(0, 0, 0, 0.3)
            .title
                color: #fff 
                font-weight: bold
                font-size: 2em
                margin-top: 1em
            .desc
                line-height: 1.5
                color: #fff
                font-weight: 400
                text-align: center
                margin: 1em 0
            .more
                font-size: 12px
                cursor: pointer
@media screen and (min-width: 1024px)
    .page
        width: 100%
        height: 100vh
        .content
            height: 100vh
            width: 100%
            position: fixed
            z-index: 3
            .bg
                height: 100%
                width: 100%
                display: block
            .text-container
                height: 100%
                width: 100%
                display: flex
                justify-content: center
                align-items: center
                flex-direction: column
                position: absolute
                z-index: 1
                top: 0
                left: 0
                .logo
                    width: 220px
                    display: block
                .desc
                    margin: 0.8em
                    font-weight: bold
                    text-align: center
                    font-size: 3em
                    color: #fff
                .tip
                    color: #999
                    font-size: 16px
                .btn
                    cursor: pointer
                    display: block
                    margin-top: 1em
                    height: 33px
                    width: 33px
        .right
            height: 100vh
            width: 100%
            position: fixed
            box-sizing: border-box
            z-index: 1
            .item
                width: 100%
                height: 100%
                .bg
                    width: 100%
                    height: 100%
                    display: block
        .left
            height: 100vh
            width: 100%
            position: fixed
            box-sizing: border-box
            z-index: 2
            opacity: 0.9
            .item
                width: 35%
                height: 100vh
                display: flex
                justify-content: center
                align-items: center
                flex-direction: column
                .crirle
                    height: 66px
                    width: 66px
                    border: 4px solid #333
                    border-radius: 50%
                    box-sizing: border-box
                    display: flex
                    justify-content: center
                    align-items: center
                    flex-direction: column
                    font-size: 12px
                    font-weight: bold
                    .line
                        height: 2px
                        width: 2em
                        background: rgba(0, 0, 0, 0.3)
                .title
                    color: #fff 
                    font-weight: bold
                    font-size: 2em
                    margin-top: 1em
                .desc
                    line-height: 1.5
                    color: #fff
                    font-weight: 400
                    text-align: center
                    margin: 1em 0
                .more
                    font-size: 12px
                    cursor: pointer
</style>